import SubmitResult from './SubmitResult';
import type { BlogArticle } from './_types';

export interface InlineDefaultProps {
  configKey?: string;
  articles?: BlogArticle[];
}

export default function InlineDefault({ configKey, articles = [] }: InlineDefaultProps) {
  return <SubmitResult type="inline" configKey={configKey} articles={articles} />;
}
